const slick = require('slick-carousel'); //TODO Use Glide instead of slick https://glidejs.com/

$('.product-features').each(function () {
    let $this = $(this);
    let $slides = $this.find('.product-feature');

    let $list = $this.find('.product-features__info');
    $this.find('.product-features__slider').slick({
        draggable: false
        , accessibility: false
        , arrows: false
        , dots: true
        , fade: true
        , rows: 0
        , appendDots: $list
        , dotsClass: 'product-features-list'
        , autoplay: true
        , autoplaySpeed: 2000
    });
    let $dots = $list.find('.product-features-list button');
    $dots.empty();
    $slides.each(function (index) {
        let $thisSlide = $(this);
        let thumb = $thisSlide.attr('data-buttonthumb');
        $dots.eq(index).append('<div class="product-features-list__title">' + $thisSlide.attr('data-title') + '</div>').append('<div class="product-features-list__details">' + $thisSlide.attr('data-description') + '</div>');
    });
});
